import { usePageMetaContext } from '~/src/contexts/PageMetaContext'
import { CategoryPosts } from '~/src/components/shared'
import { nonNullable } from '~/src/utils'
import { PostCoverType } from '~/src/components/post/PostCard'

interface Props {
	coverType: PostCoverType
}

export function PagePosts({ coverType }: Props) {
  const { data } = usePageMetaContext()
  const categories = data?.categories?.map(item => item?.category).filter(nonNullable) ?? []

  return (
    <>
      {categories.map((category) => (
        <CategoryPosts
          key={category.categoryId}
          category={category}
          coverType={coverType}
          showMore
          displayOption={data?.displayOption ?? undefined} />
      ))}
    </>
  )
}